<template>
    <b-navbar toggleable="lg" type="dark" variant="primary" fixed>
        <div class="container">
            <b-navbar-brand to="/app">
                <img src="../assets/logo_white.png" alt="Logo" class="img-fluid">
            </b-navbar-brand>

            <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

            <b-collapse id="nav-collapse" is-nav>
                <b-navbar-nav>
                    <b-nav-item to="/app">
                        Dashboard
                    </b-nav-item>
                </b-navbar-nav>
                <b-navbar-nav>
                    <b-nav-item to="/accounts">
                        Accounts
                    </b-nav-item>
                </b-navbar-nav>
                <b-navbar-nav class="d-md-none">
                    <b-nav-item to="/accounts">
                        Profile
                    </b-nav-item>
                </b-navbar-nav>
                <b-navbar-nav class="d-md-none">
                    <b-nav-item to="/accounts">
                        <fa-icon icon="sign-out-alt"/>&nbsp;Sign Out
                    </b-nav-item>
                </b-navbar-nav>

                <!-- Right aligned nav items -->
                <b-navbar-nav class="ml-auto d-none d-md-block">


                    <b-nav-item-dropdown right>
                        <!-- Using 'button-content' slot -->
                        <template v-slot:button-content>
                            <em>User</em>
                        </template>
                        <b-dropdown-item to="/profile">Profile</b-dropdown-item>
                        <b-dropdown-item @click="logout">Sign Out</b-dropdown-item>
                    </b-nav-item-dropdown>
                </b-navbar-nav>
            </b-collapse>
        </div>
    </b-navbar>
</template>

<script>
    export default {
        name: "Navbar",
        methods: {
            logout() {
                this.$firebase.auth().signOut().then(() => {
                    this.$store.commit('updateUser', null);
                    this.$router.push({path: "/login"});
                })
            }
        }
    }
</script>
